module.exports = __webpack_public_path__ + "img/h1-3.997f889.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/h1-3.png
// module id = 3Inv
// module chunks = 15